import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function DropDownMenu({
  children,
  trigger = ({ ref, onClick, open }) => {
    return (
      <button ref={ref} onPointerDown={onClick} style={{ backgroundColor: open ? "red" : "transparent" }}>
        Template
      </button>
    );
  },
  closeOnClick = true,
  absolute = true,
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const dropDownRef = useRef(null);

  const toggle = () => setOpen((v) => !v);
  const close = () => setOpen(false);

  // CODE FOR FIXED POSITIONING
  // const [style, setStyle] = useState({
  //   position: "fixed",
  //   top: 0,
  //   left: 0,
  //   zIndex: 999999,
  // });
  //   const updatePosition = () => {
  //     if (!triggerRef?.current || !dropDownRef?.current) return;

  //     const triggerRect = triggerRef.current.getBoundingClientRect();
  //     const dropDownRect = dropDownRef.current.getBoundingClientRect();

  //     let top = triggerRect.bottom;
  //     let left = triggerRect.right - dropDownRect.width;

  //     setStyle({
  //       position: "fixed",
  //       top,
  //       left,
  //       zIndex: 999999,
  //     });
  //   };
  //   useLayoutEffect(() => {
  //     if (!open) return;
  //     updatePosition();
  //   }, [open]);
  //   useEffect(() => {
  //     if (!open) return;
  //     window.addEventListener("scroll", updatePosition, true);
  //     window.addEventListener("resize", updatePosition);
  //     return () => {
  //       window.removeEventListener("scroll", updatePosition, true);
  //       window.removeEventListener("resize", updatePosition);
  //     };
  //   }, [open]);

  // Outside click detection (Safari-safe)
  useEffect(() => {
    if (!open) return;
    function handlePointerDown(e) {
      const t = e?.target;
      if (triggerRef.current?.contains(t) || dropDownRef.current?.contains(t)) return;
      close();
    }
    document.addEventListener("pointerdown", handlePointerDown);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [open]);

  const handleInsideClick = (e) => {
    if (e.target?.dataset?.noclose === "true") return; //Don't close if clicked element has data-noclose
    if (e.target?.dataset?.close === "true") close(); //The reverse
    if (closeOnClick) close();
  };

  return (
    <>
      {trigger({ ref: triggerRef, onClick: toggle, open: open })}
      {
        open && (
          <div
            ref={dropDownRef}
            onClick={handleInsideClick}
            style={{}}
            className={`${absolute ? "absolute" : ""} top-full right-0 w-max max-w-[100vw] z-50`}
          >
            {children}
          </div>
        )
        // CODE FOR FIXED POSITION
        // createPortal(
        // <div ref={dropDownRef} onClick={handleInsideClick} style={style}>
        //     {children}
        //   </div>
        //   ,
        //   document.body
        // )
      }
    </>
  );
}
